$(function() {

  if ( ('#portfolio').length ) {

    var setSlidesHeight = function() {
      var viewport = $(window).height() - $('#header').height();
      $('.portfolio-section').outerHeight( viewport );
      // $('.scrollmagic-pin-spacer').css('marginTop', -viewport);
    }
    setSlidesHeight();
    $(window).resize(function() {
      setSlidesHeight();
    });

    var addMouse = function() {
      var portfolioSections = $('.portfolio-section:not(.gallery-section)').not(':last');
      if ( portfolioSections.length ) {
        portfolioSections.each(function() {
          $(this).append( $('<div class="scroll-mouse"></div>') );
        });
        $('.scroll-mouse').click(function(e) {
          e.deltaY = -1;
          scrollOver(e);
        });
      }
    }
    addMouse();

    $('.swapper').each(function() {
      var $swapper = $(this),
          $overlay = $swapper.find('.swapper-overlay'),
          $control = $('<div class="swapper-control"></div>').appendTo( $overlay ),
          $controlPin = $('<span class="control-pin"></span>').appendTo( $control );

      $control.draggable({
        axis: 'x',
        handle: $controlPin,
        containment: $swapper,
        drag: function(e, ui) {
          var pos = ui.position.left;
          $overlay.width( pos );
        }
      });

      $swapper.click(function(e) {
        if ( $(e.target).closest('.swapper-control').length ) return;
        console.log(e);
        var pos = e.offsetX;
        $overlay.width( pos );
        $control.css({left: 'auto', right: '0'});
      });
    });

    var locationHash = window.location.hash,
        currentPage = locationHash.replace('#', '') || currentPage || null;

    $.getJSON('/js/src/projects.json', function(json) {

      var portfolio = new Vue({
        el: '#portfolio',
        data: {
          categories: json.categories,
          projects: json.projects,
          currentPage: currentPage
        },
        watch: {
          'currentPage': function(val, oldVal) {
            hideDuplicates();
            setSlidesHeight();
            portfolioScrollInit();
          }
        },
        ready: function() {
          setSlidesHeight();
          addMouse();
        },
        components: {
          'project-tile': {
            inherit: true,
            data: function() {
              return {
                isHovered: false,
                hoverTimeout: null
              }
            },
            methods: {
              setHover: function() {
                var self = this;
                self.hoverTimeout = setTimeout(function() {
                  self.isHovered = true;
                }, 500);
              },
              removeHover: function() {
                this.isHovered = false;
                clearTimeout(this.hoverTimeout);
              }
            },
            ready: function() {
              var element = $(this.$el);
              if ( element.offset().left + element.width() >= $(window).width() ) {
                element.addClass('last');
              }
            }
          },
          'menu-item': {
            inherit: true,
            methods: {
              changeSection: function(e) {
                e.preventDefault();
                var section = e.target.getAttribute('href'),
                    url = window.location.pathname;
                this.currentPage = section;
                $.overlayLoader(false, 'main-menu');
                history.pushState(null, null, url + '#' + section);
              }
            }
          }
        }
      });

      if ( $('.inner-page').length ) {
        hideDuplicates();
        portfolioScrollInit();

        window.addEventListener('popstate', function(e) {
          locationHash = window.location.hash;
          currentPage = locationHash.replace('#', '') || null;
          portfolio.currentPage = currentPage;
        }, false);
      }

    });

    Vue.filter('unbr', function(value) {
      // Удаляет из строки ручные переносы
      return value.replace('<br />', '').replace('<br/>', '').replace('<br>', '');
    });

    Vue.filter('fuckp', function(value) {
      // Удаляет из строки параграфы, вставленные визивигом, бесят они
      return value.replace('<p>', '').replace('</p>', '');
    });

    Vue.filter('firstin', function(value) {
      // Удаляет повторяющиеся проекты из разных разделов на основной разводной
      if ( this.currentPage != null ) return value;
      result = [];
      value.forEach(function(element, index, array) {
        var currentItem = element,
            duplicate = false;
        result.forEach(function(element, index, array) {
          if ( element.name == currentItem.name ) {
            duplicate = true;
            return false;
          }
        });
        if ( !duplicate ) {
          result.push(element);
        }
      });
      return result;
    });

    Vue.filter('withoutSections', function(value) {
      // Удаляет корневые разделы из типов
      result = [];
      value.forEach(function(element, index, array) {
        if ( element.section != element.type ) {
          result.push(element);
        }
      });
      return result;
    });

    Vue.filter('sectionsFilter', function(value) {
      // Перебирает секции портфолио вместо разделов
      // (например, в секцию Дизайн сайтов входят разделы Интернет-магазины, Корпоративные сайты
      // и проч.)
      result = [];
      value.forEach(function(element, index, array) {
        var currentItem = element,
            duplicate = false;
        result.forEach(function(element, index, array) {
          if ( element.section == currentItem.section ) {
            duplicate = true;
            return false;
          }
        });
        if ( !duplicate ) {
          result.push(element);
        }
      });
      return result;
    });

    Vue.filter('showInPortfolio', function(value) {
      // Скрывает проекты по флагу "показывать в портфолио"
      result = [];
      value.forEach(function(element, index, array) {
        if ( element.showPortfolio ) {
          result.push(element);
        }
      });
      return result;
    });

    Vue.filter('showOnIndex', function(value) {
      // Скрывает проекты по флагу "показывать на главной"
      result = [];
      value.forEach(function(element, index, array) {
        if ( element.showOnIndex ) {
          result.push(element);
        }
      });
      return result;
    });

    var portfolioScrollInit = function() {
      $('.portfolio-section').each(function() {
        var self = $(this);
        // if ( self.closest('.scrollmagic-pin-spacer').length ) {
        //   self = self.closest('.scrollmagic-pin-spacer');
        // }
        self.bind('inview', function(event, isInView, visiblePartX, visiblePartY) {
          if (isInView) {
            // element is now visible in the viewport
            self.addClass('inview');
            if (visiblePartY == 'top') {
              // top part of element is visible
              self.removeClass('inview-bottom')
            } else if (visiblePartY == 'bottom') {
              // bottom part of element is visible
              self.addClass('inview-bottom')
            } else {
              // whole part of element is visible
              self.addClass('inview-bottom')
            }
          } else {
            // element has gone out of viewport
            self.removeClass('inview inview-bottom');
          }
        });
      });
    }

    var hideDuplicates = function() {
      $('.portfolio-section').each(function() {
        var self = this;
        if ( $(self).is(':visible') ) {
          $('.portfolio-section').each(function() {
            if ( ($(self).attr('data-index') != $(this).attr('data-index')) &&
                 ($(self).attr('data-name') == $(this).attr('data-name')) ) {
              $(this).hide();
            }
          });
        }
      });
      $('.portfolio-section:hidden').remove();
    }

    var scrollOver = function(e) {
      // Перемотка до следующего блока по колесику мышки
      var currentBlock = $('.portfolio-section.inview:last');
      if ( !currentBlock.length ) return;
      var currentBlockTop = parseInt(currentBlock.offset().top, 10),
          currentBlockBottom = parseInt(currentBlockTop + currentBlock.height(), 10),
          scrollTop = $(window).scrollTop(),
          windowHeight = $(window).height();
      if (e.deltaY <= 0) {
        if (( !currentBlock.hasClass('inview-bottom') ||
               currentBlock.index('.portfolio-section') != $('.portfolio-section').length - 1 ) &&
              !currentBlock.hasClass('disable-autoscroll') ) {
          e.preventDefault();
          if ( currentBlockBottom > scrollTop + windowHeight ) {
            $(window).scrollTo(currentBlockBottom - windowHeight, {axis: 'y', duration: 700});
          } else {
            $(window).scrollTo(currentBlockBottom - $('#header').height(), {axis: 'y', duration: 700});
          }
        }
      } else {
        // if (e.deltaY >= 0 && $(window).scrollTop() > 0 ) {
        //   e.preventDefault();
        //   var prevBlock = currentBlock.prev();
        //   if ( !prevBlock.length ) {
        //     prevBlock = currentBlock.parent().prev();
        //   }
        //   $(window).scrollTo(prevBlock.offset().top, {axis: 'y', duration: 700});
        // }
      }
    }

    var scrollOverCycle = function(e) {
      scrollOver(e);
      $(window).off('mousewheel.default');
      setTimeout(function() {
        $(window).on('mousewheel.default', function(e) {
          scrollOverCycle(e);
        });
      }, 700);
    }

    $(window).on('mousewheel.default', function(e) {
      scrollOverCycle(e);
    });

    var galleryPrev = function() {
      var gallery = $('#gallery'),
          anchor = $('.gallery-block .active'),
          currentSrc = anchor.attr('href'),
          src = currentSrc,
          galleryPics = anchor.closest('.gallery-block'),
          nextPic;
      while ( currentSrc == src ) {
        nextPic = anchor.prev('a');
        if ( !nextPic.length ) {
          nextPic = galleryPics.find('a:last');
        }
        src = nextPic.attr('href');
        nextPic.addClass('active').siblings().removeClass('active');
        if ( currentSrc == src ) {
          anchor = anchor.prev('a');
          if ( !anchor.length ) {
            nextPic = galleryPics.find('a:last');
          }
        }
      }
      gallery.css('backgroundImage', 'url('+src+')');
    }

    var galleryNext = function() {
      var gallery = $('#gallery'),
          anchor = $('.gallery-block .active'),
          currentSrc = anchor.attr('href'),
          src = currentSrc,
          galleryPics = anchor.closest('.gallery-block'),
          nextPic;
      while ( currentSrc == src ) {
        nextPic = anchor.next('a');
        if ( !nextPic.length ) {
          nextPic = galleryPics.find('a:first');
        }
        src = nextPic.attr('href');
        nextPic.addClass('active').siblings().removeClass('active');
        if ( currentSrc == src ) {
          anchor = anchor.next('a');
          if ( !anchor.length ) {
            nextPic = galleryPics.find('a:first');
          }
        }
      }
      gallery.css('backgroundImage', 'url('+src+')');
    }

    $('.gallery-block a').click(function(e) {
      e.preventDefault();
      var self = $(this),
          src = self.attr('href'),
          gallery = $('#gallery');
      gallery.css('backgroundImage', 'url('+src+')').stop(true, true).fadeIn();
      self.addClass('active');
    });

    $('.gallery-popup .js-close').click(function(e) {
      e.preventDefault();
      $(this).closest('.popup').stop(true, true).fadeOut();
      $('.gallery-block .active').removeClass('active');
    });

    $('.gallery-popup .prev, .gallery-popup .next').click(function(e) {
      e.preventDefault();
      var self = $(this);
      if ( self.hasClass('prev') ) {
        galleryPrev();
      } else {
        galleryNext();
      }
    });

    $(window).on('keydown', function(e) {
      if ( !$('.gallery-popup:visible').length ) return;
      if ( e.keyCode == 37 ) {
        galleryPrev();
      } else if ( e.keyCode == 39 ) {
        galleryNext();
      }
    });

  }

});